import axios from "axios";
const baseUrl = "c-vehicle-group";

export default {
  all() {
    return axios.post(baseUrl + "/all");
  },
};
